export default __webpack_public_path__ + "static/media/banner-mobile-visiting-program.3802a64a.webp";